import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import { FilterComponentProps } from "./UserProfileFilters";
import { IconCancel } from "@/icons";
import SearchIcon from "@mui/icons-material/Search";

interface SearchFilterProps extends FilterComponentProps {
  value: string;
  onChange: (value: string) => void;
}

const SearchFilter: React.FC<SearchFilterProps> = ({ value, onChange }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <TextField
      size="small"
      value={value}
      onChange={handleChange}
      placeholder="Search by name or email"
      variant="outlined"
      sx={{
        width: 300,
        "& .MuiOutlinedInput-root": {
          borderRadius: "20px",
          height: 40,
        },
      }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
          endAdornment: value ? (
            <InputAdornment position="end">
              <IconCancel
                style={{ cursor: "pointer" }}
                onClick={() => onChange("")}
                fontSize="small"
              />
            </InputAdornment>
          ) : null,
        },
      }}
    />
  );
};

export default SearchFilter;
